import { UPDATE, CLEAR } from "./../constants/action_types";
export const set_song = (song) => async (dispatch) =>
{
  try
  {
    navigator.mediaSession.metadata.title = song.title;
    navigator.mediaSession.metadata.artist = song.artist;
    navigator.mediaSession.metadata.album = song.album;
    dispatch({ type: UPDATE, payload: song });
  }
  catch (err)
  {
    console.trace(err);
  }
}

export const clear_song = () => async (dispatch) =>
{
  try
  {
    dispatch({ type: CLEAR });
  }
  catch (err)
  {
    console.trace(err);
  }
}

